<template>
  <div :class="sentiment" :style="{width: `${width}px`, height: `${height}px`}">
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    sentiment: {
      type: String,
      default: 'positive'
    }
  }
};
</script>

<style lang="scss" scoped>
.positive {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-image: linear-gradient(90deg, rgba(255, 91, 101, 0.3) 0%, rgba(255, 91, 101, 0.1) 100%);
}
.negative {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-image: linear-gradient(90deg, rgba(54, 194, 146, 0.3) 0%, rgba(54, 194, 146, 0.1) 100%);
}
.neutral, .all {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-image: linear-gradient(90deg, rgba(158, 161, 180, 0.3) 0%, rgba(158, 161, 180, 0.1) 100%);
}
</style>
